import COLORS from "./__generated__/base_colors";

type ExtendedColors = typeof COLORS & {
  BLUE_GRADIENT: string;
  BLUE_GRADIENT_DARK: string;
  INDIGO_500: string;
};

const extendedColors: ExtendedColors = {
  ...COLORS,
  BLUE_GRADIENT: "linear-gradient(92deg, #0068A7 0%, #009CEA 100%)",
  BLUE_GRADIENT_DARK: "linear-gradient(93deg, #004980 0%, #0088D6 92%)",
  INDIGO_500: "#4558BF",
};

export default extendedColors;
